import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getToken, logIn, createAccount } from '../api/auth';

export const authLogin = createAsyncThunk(
  'auth/login',
  async ({ login, password }) => {
    const data = await logIn({ login, password });
    return data; // { token, user, ... }
  }
);

export const authRegister = createAsyncThunk(
  'auth/register',
  async ({ login, password, nick, description }) => {
    const data = await createAccount({ login, password, nick, description });
    return data; // { token, user, ... } (match your lambda)
  }
);

const initialState = {
  user: null,
  token: null,
  status: 'idle',
  error: null,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    hydrate(state) {
      try {
        const raw = localStorage.getItem('wal_auth');
        if (!raw) return;
        const parsed = JSON.parse(raw);
        state.user = parsed.user || null;
        state.token = parsed.token || null;
      } catch {}
    },
    signOut(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem('wal_auth');
    },
  },
  extraReducers(builder) {
    builder
      .addCase(authLogin.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(authLogin.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.user = a.payload.user || null;
        s.token = a.payload.token || null;
        localStorage.setItem('wal_auth', JSON.stringify({ user: s.user, token: s.token }));
      })
      .addCase(authLogin.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
      .addCase(authRegister.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(authRegister.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.user = a.payload.user || null;
        s.token = a.payload.token || null;
        localStorage.setItem('wal_auth', JSON.stringify({ user: s.user, token: s.token }));
      })
      .addCase(authRegister.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; });
  },
});

export const { hydrate: authHydrate, signOut: authSignOut } = slice.actions;

export const selectAuthUser   = (s) => s.auth.user;
export const selectAuthToken  = (s) => s.auth.token;
export const selectAuthStatus = (s) => s.auth.status;
export const selectAuthError  = (s) => s.auth.error;

export default slice.reducer;